import React from "react";
import {
	Grid,
	Col,
	Text,
	Link,
	Button,
	CloudinaryImage,
} from "@website-builder/ui/shared/elements";
//styles
import {
	DualCTAWrapper,
	CardWrapper,
	CardContentWrapper,
	ActionWrapper,
} from "./styles";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";

const DualCTA = ({ dualCTACardItems }) => {
	// is cards with media
	const withMedia = dualCTACardItems[0]?.media;
	//CTACard component
	const CTACard = ({
		description,
		heading,
		backgroundColor,
		cta,
		isDarkBg,
		media,
	}) => {
		//  represents text color based on card bg
		const textColor = isDarkBg
			? {
					base: "primary",
					color: "neutral",
					shade: "white",
				}
			: {
					base: "primary",
					color: "nightshade",
					shade: "800",
				};

		return (
			<Col span={6} mdSpan={6}>
				<CardWrapper bgColor={backgroundColor} hasMedia={media}>
					<CardContentWrapper>
						<Text variant="headline_3" tag="h2" color={textColor}>
							{heading}
						</Text>
						<Text
							variant={withMedia ? "paragraph_S" : "paragraph_L"}
							color={textColor}
							tag="div"
							dangerouslySetInnerHTML={{ __html: description }}
						/>
					</CardContentWrapper>
					{(media || cta) && (
						<CardContentWrapper className="card-with-media">
							{media && (
								<CloudinaryImage
									className="cta-image"
									url={media?.image?.image}
									quality="auto"
									lazyload
									fetchFormat="auto"
									dynamic
								/>
							)}
							{cta &&
								(cta?.component === "LinkWR" ? (
									<ActionWrapper darkBg={isDarkBg}>
										<Link
											className="cta-card-action"
											arrowCta
											darkBg={isDarkBg}
											disabled={cta?.disabled}
											onClick={() => handleCTAClick(cta)}
											linkText={cta?.linkText}
											href={cta?.link?.link}
										/>
									</ActionWrapper>
								) : (
									<ActionWrapper darkBg={isDarkBg}>
										<Button
											{...cta}
											type={cta.type}
											buttonText={cta?.buttonText}
											darkBg={isDarkBg}
											disabled={cta?.disabled}
											onClick={() => handleCTAClick(cta)}
										></Button>
									</ActionWrapper>
								))}
						</CardContentWrapper>
					)}
				</CardWrapper>
			</Col>
		);
	};
	return (
		<DualCTAWrapper>
			<Grid hMargin={withMedia ? [150, 24] : [96, 24]}>
				{dualCTACardItems.map((item, index) => (
					<CTACard {...item} key={`${item?.heading}+${index}`} />
				))}
			</Grid>
		</DualCTAWrapper>
	);
};

export default DualCTA;
